import React from "react"
import { graphql, Link } from "gatsby"

import Layout from "../components/layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import RecommendedReading from "../components/recommended-reading"
import ContactUsSection from "../components/contact-us-section"
import SocialMediaWidget from "../components/social-media-widget"
// import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Breadcrumb from "../components/breadcrumbs"

const Text = ({ children }) => <p className="align-center">{children}</p>

const options = {
  renderMark: {
    [MARKS.BOLD]: text => <strong>{text}</strong>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
    [BLOCKS.EMBEDDED_ASSET]: node => {
      return (
        <>          
          <img src={node.data.target.fixed.src}/>
        </>
      )
    },
  },
}

export const query = graphql`
  query ($slug: String!) {
    contentfulBlogPost(slug: {eq: $slug}) {
      title
      postDate(formatString: "MMM D, YYYY")
      body {
        raw
        references {
          __typename
          ... on ContentfulAsset {
            contentful_id
            fixed(width: 1600) {
              width
              height
              src
              srcSet
            }
          }
        }
      }
      category
      slug
      youtubeVideoId
      displayThumbnail
      thumbnailLink
      featuredImage {
        fluid(maxWidth: 1000) {
            src
            aspectRatio
        }
      }
    }
  }
`

const BlogPost = (props) => {

  let categoryClass = ''

  switch (props.data.contentfulBlogPost.category) {
    case '1P Suppliers':
      categoryClass = 'one-p-suppliers-icon-bg'
      break;
    case 'Agencies':
      categoryClass = 'agencies-icon-bg'
      break;
    case 'Announcements':
      categoryClass = 'announcements-icon-bg'
      break;
    case 'Case Study':
      categoryClass = 'case-study-icon-bg'
      break;
    case 'Content Center':
      categoryClass = 'content-center-icon-bg'
      break;
    case 'Customer Experience':
      categoryClass = 'customer-experience-icon-bg'
      break;
    case 'Discoverability':
      categoryClass = 'discoverability-icon-bg'
      break;
    case 'Dojo':
      categoryClass = 'dojo-icon-bg'
      break;
    case 'Enhanced Content':
      categoryClass = 'enhanced-content-icon-bg'
      break;
    case 'Insights':
      categoryClass = 'insights-icon-bg'
      break;
    case 'Marketplace Sellers':
      categoryClass = 'marketplace-icon-bg'
      break;
    case 'Paid Search':
      categoryClass = 'paid-search-icon-bg'
      break;
    case 'Podcasts':
      categoryClass = 'webinar-icon-bg'
      break;
    case 'Seller Suite':
      categoryClass = 'seller-suite-icon-bg'
      break;
    case 'Strategy & Services':
      categoryClass = 'strategy-icon-bg'
      break;
    case 'Webinar':
      categoryClass = 'webinar-icon-bg'
      break;
    case 'Win Search':
      categoryClass = 'win-search-icon-bg'
      break;
    default:
      categoryClass = 'other-icon-bg'
      break;
  }

  return (
    <Layout>
      <SEO title={props.data.contentfulBlogPost.title} />
      <div id='page-banner' className={categoryClass}>
        <div className='container'>
          <Breadcrumb location={props.location}/>
          <div className='row'>
            <div className='col-lg-8 col-md-10 py-6'>
              <span className="text-white font-md pb-2"> {props.data.contentfulBlogPost.postDate} </span>
              <h1 className='text-white text-uppercase mb-0'>{props.data.contentfulBlogPost.title}</h1>
              <span className="text-white font-md text-uppercase"> {props.data.contentfulBlogPost.category === null ? 'Other' : props.data.contentfulBlogPost.category} </span>
            </div>
          </div>
        </div>
      </div>
      <div id='blog-content' className="container py-6">
        <div className='row position-relative'>
          <SocialMediaWidget title={props.data.contentfulBlogPost.title} slug={props.data.contentfulBlogPost.slug}/>
          <div className='col-lg-2 col-md-2 col-sm-3'></div>
          <div className='col-lg-8 col-md-10 col-sm-9'>
            
            {props.data.contentfulBlogPost.youtubeVideoId !== null ?
              <div className="embed-responsive embed-responsive-16by9" style={{marginBottom:'1rem'}}>
                <iframe width="560" height="315" src={`https://www.youtube.com/embed/${props.data.contentfulBlogPost.youtubeVideoId}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            :
              <></>
            }

            {props.data.contentfulBlogPost.displayThumbnail ?
              <Link to={props.data.contentfulBlogPost.thumbnailLink}>
                <Img className="mb-4" fluid={props.data.contentfulBlogPost.featuredImage.fluid} alt={props.data.contentfulBlogPost.title}/>
              </Link>
              :
              <></>
            }

            {renderRichText(props.data.contentfulBlogPost.body, options)}
            
          </div>
          <div className='col-lg-2 col-sm-0'></div>
        </div>
      </div>
      <div className='icon-background-primary py-6'>
        <div className='container'>
          <h1 className='mb-5 text-center text-dark text-uppercase'>Recommended Reading</h1>
          <RecommendedReading category={props.data.contentfulBlogPost.category} title={props.data.contentfulBlogPost.title}/>
        </div>
      </div>
      <div className='py-6'>
        <ContactUsSection/>
      </div>
    </Layout>
  )
}

export default BlogPost